import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import MainSite from './components/MainSite';
import DataPortal from './pages/DataPortal';
import CaseStudies from './pages/CaseStudies';
import HeatPumpSizing from './pages/HeatPumpSizing';
import Privacy from './pages/Privacy';
import CookieBanner from './components/CookieBanner';
import { loadAnalytics, trackPageView } from './lib/analytics';
import './index.css';

// Sends a GA4 page_view on every client-side route change, including the first
// load. Both calls are no-ops unless the visitor has accepted analytics cookies.
function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    loadAnalytics();
    trackPageView(location.pathname + location.search);
  }, [location]);
}

function AppRoutes() {
  usePageTracking();
  return (
    <>
    <CookieBanner />
    <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/data-portal" element={<DataPortal />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/heat-pump-sizing" element={<HeatPumpSizing />} />
        <Route path="/privacy" element={<Privacy />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;